module.exports = __webpack_public_path__ + "img/b3a8da0.jpg";